import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from '../../ui/PrimaryButton/PrimaryButton';
import { useAppStore } from '../../hooks/useAppStore';
import { useFeedbackActions } from '../../../modules/feedback/hooks/useFeedbackActions';
import { useVmFeatures } from '../../hooks/useVmFeatures';
import { QR_SERVICES } from '../../constants';
import { getVmDetails } from '../../lib/general';

const FeedbackCustom = () => {
    const { t } = useTranslation();
    const vm = useAppStore((s) => s.vm);
    const { showFeedbackGlobal } = useVmFeatures();
    const { onFeedbackClickHandler } = useFeedbackActions();
    const { isAllowed } = getVmDetails(vm);
    const [isFeedbacksActive, setIsFeedbacksActive] = useState<boolean>(
        Boolean(showFeedbackGlobal),
    );

    useEffect(() => {
        if (vm.QRservices === QR_SERVICES.SEPARATED_SERVICES && isAllowed) {
            setIsFeedbacksActive(false);
        }
    }, []);
    return (
        <>
            {isFeedbacksActive && (
                <PrimaryButton type="button" onClick={onFeedbackClickHandler}>
                    {t('Feedback')}
                </PrimaryButton>
            )}
        </>
    );
};
export { FeedbackCustom };
